module.exports = __webpack_public_path__ + "static/capturing-data-and-the-rise-of-tex-tenant-experience-in-cre-36dc315f95b4aaab9d53e3c19b1acdac.png";